/* eslint-env browser */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/gatsby';

import FieldHelpText from '~components/forms/HelpText';
import { SelectStandalone } from '~components/forms/inputs/Select';
import Label from '../forms/Label';
import axios from '../../utils/axios';

export default function RegionPicker({ state, value, onSelect }) {
  const [regionList, setRegionList] = useState(null);
  const [loadingError, setLoadingError] = useState(null);

  useEffect(() => {
    let canceled = false;

    setRegionList(null);
    setLoadingError(null);

    axios
      .get(`official/state/${state}/`)
      .then(({ data: newRegionList }) => {
        if (canceled) {
          return;
        }

        setRegionList(newRegionList);
      })
      .catch((err) => {
        if (canceled) {
          return;
        }

        Sentry.captureException(err);
        setLoadingError('Error loading regions. Please try again.');
      });

    return () => {
      canceled = true;
    };
  }, [state]);

  const isLoading = regionList === null;

  const handleChange = (evt) => {
    onSelect(evt.target.value);
  };

  let options = [];
  if (regionList) {
    options = [{ value: '', label: 'Select a region' }].concat([
      ...regionList.map(
        // eslint-disable-next-line camelcase
        ({ name, external_id }) => ({ label: name, value: external_id })
      ),
    ]);
  }

  return (
    <div className='form-control w-full'>
      <Label htmlFor='leo-region-picker'>Region</Label>
      <SelectStandalone
        elementId='leo-region-picker'
        name='leo-region'
        value={value}
        onChange={handleChange}
        disabled={isLoading}
      >
        {/* eslint-disable-next-line no-shadow */}
        {options.map(({ label, value }) => (
          <option key={`${value}`} value={value}>
            {label}
          </option>
        ))}
      </SelectStandalone>
      {loadingError && <FieldHelpText isError>{loadingError}</FieldHelpText>}
    </div>
  );
}

RegionPicker.propTypes = {
  state: PropTypes.string.isRequired,
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};
